import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getLocations, createLocation, deleteLocation } from '../services/api';
import { MapPin, Plus, Trash2 } from 'lucide-react';

const LocationList = () => {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({ name: '', description: '' });
  const navigate = useNavigate();

  useEffect(() => {
    fetchLocations();
  }, []);

  const fetchLocations = async () => {
    try {
      const response = await getLocations();
      setLocations(response.data);
    } catch (error) {
      console.error('Error fetching locations:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await createLocation(formData);
      setFormData({ name: '', description: '' });
      setShowForm(false);
      fetchLocations();
    } catch (error) {
      console.error('Error creating location:', error);
    }
  };

  const handleDelete = async (id, e) => {
    e.stopPropagation();
    if (window.confirm('Are you sure you want to delete this location? This will also delete all containers and items within it.')) {
      try {
        await deleteLocation(id);
        fetchLocations();
      } catch (error) {
        console.error('Error deleting location:', error);
      }
    }
  };

  if (loading) return <div className="container">Loading...</div>;

  return (
    <div className="container">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h1>Locations</h1>
        <button onClick={() => setShowForm(!showForm)} className="button">
          <Plus size={20} style={{ display: 'inline', marginRight: '5px' }} />
          Add Location
        </button>
      </div>

      {showForm && (
        <div className="card">
          <h2>New Location</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="label">Name</label>
              <input
                type="text"
                className="input"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                required
              />
            </div>
            <div className="form-group">
              <label className="label">Description</label>
              <textarea
                className="input"
                rows="3"
                value={formData.description}
                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              />
            </div>
            <div style={{ display: 'flex', gap: '10px' }}>
              <button type="submit" className="button">Create</button>
              <button type="button" onClick={() => setShowForm(false)} className="button button-secondary">
                Cancel
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="grid">
        {locations.map((location) => (
          <div
            key={location.id}
            className="list-item"
            onClick={() => navigate(`/locations/${location.id}`)}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div style={{ flex: 1 }}>
                <h3>
                  <MapPin size={20} style={{ display: 'inline', marginRight: '8px' }} />
                  {location.name}
                </h3>
                {location.description && (
                  <p style={{ color: '#666', marginTop: '8px' }}>{location.description}</p>
                )}
              </div>
              <button
                onClick={(e) => handleDelete(location.id, e)}
                className="button button-danger"
                style={{ padding: '5px 10px' }}
              >
                <Trash2 size={16} />
              </button>
            </div>
          </div>
        ))}
      </div>

      {locations.length === 0 && (
        <div className="card" style={{ textAlign: 'center', color: '#666' }}>
          <p>No locations yet. Create one to get started!</p>
        </div>
      )}
    </div>
  );
};

export default LocationList;
